import React from "react";
import { MDBTooltip } from "mdb-react-ui-kit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTag } from "@fortawesome/free-solid-svg-icons";
import { shipmentLabelHref } from "../../utils/shipmentLabelUrl";

function IconAction({ label, icon, disabled, onClick }) {
  return (
    <MDBTooltip
      tag="span"
      title={label}
      placement="top"
      wrapperProps={{ className: "trackhub-reports-cancel-wrap" }}
    >
      <span className="trackhub-reports-cancel-wrap">
        <button
          type="button"
          className="trackhub-reports-icon-btn"
          disabled={disabled}
          aria-label={label}
          onClick={onClick}
        >
          <FontAwesomeIcon icon={icon} />
        </button>
      </span>
    </MDBTooltip>
  );
}

export default function ShipmentDocumentButtons({ row, t }) {
  const printHref = shipmentLabelHref(row?.labelUrl, { print: true });
  if (!printHref) return null;

  const tooltip = t("shipmentsPage.details.printLabel");

  return (
    <IconAction
      label={tooltip}
      icon={faTag}
      disabled={false}
      onClick={(event) => {
        event.stopPropagation();
        window.open(printHref, "_blank", "noopener,noreferrer");
      }}
    />
  );
}
